<template>
  <div>
    <component :is="getComponent"/>
  </div>
</template>

<script>
import DashboardAppointments from "@/views/cpanel/dashboard/Appointments.vue"
import DashboardVisits from "@/views/cpanel/dashboard/Visits.vue"
import {mapState} from "vuex";

export default {
  name: "dashboard",
  components: {
    DashboardAppointments,
    DashboardVisits,
  },
  data() {
    return {}
  },
  created() {
  },
  computed: {
    ...mapState("auth", {
      user: (state) => state.profile,
    }),
    getComponent() {
      return this.features('screening_plus') ? 'DashboardAppointments' : 'DashboardVisits'
    }
  },
  methods: {
    features(type) {
      if (!this.user) return false
      if (this.user.features.includes(type)) {
        return true
      } else return false
    },
  }
}
</script>

<style scoped>

</style>